import React from 'react'
import CompanyName from './CompanyName';
import Developed from './Developed';
import Divider from '@mui/material/Divider';

const today = new Date();

const Footer = () => {
  return (
    <footer className='max-w-[1200px] mx-auto px-8 pt-8'>
    
      
       <div className='pt-4 text-[#1D4E89]' > <Divider textAlign="left">&copy; {today.getFullYear()} - <CompanyName /></Divider></div>
       <div className='py-4 print:invisible'><Developed /></div>
    </footer>
  )
}

export default Footer
